import React from 'react'
import PropTypes from 'prop-types'
import { Formik as FormikForm } from 'formik'
import * as yup from 'yup'

import Form from './Form'
import encode from './encode'

const Formik = ({ displayModal }) => (
  <FormikForm
    initialValues={{
      name: ``,
      email: ``,
      message: ``,
    }}
    validationSchema={yup.object().shape({
      name: yup.string().required(`Name is required.`),
      email: yup
        .string()
        .email(`Invalid email address`)
        .required(`Email is required.`),
      message: yup.string().required(`Message is required.`),
    })}
    onSubmit={(values, { setSubmitting, resetForm }) => {
      fetch(`/`, {
        method: `POST`,
        headers: { 'Content-Type': `application/x-www-form-urlencoded` },
        body: encode({ 'form-name': `contact`, ...values }),
      })
        .then(() => {
          displayModal()
          resetForm()
          setSubmitting(false)
        })
        .catch(error => console.log(error))
    }}
    component={Form}
  />
)

Formik.propTypes = {
  displayModal: PropTypes.func,
}

export default Formik



// WEBPACK FOOTER //
// ./src/containers/Contact/Formik.js